import React from 'react'
import Button from 'components/CustomButtons/Button.js'
import Editor from 'react-simple-wysiwyg'
import { io } from 'socket.io-client'
import { useState } from 'react'
import { DeleteForeverTwoTone, HighlightOffTwoTone, PostAddTwoTone } from '@material-ui/icons'
import MediaDrop from 'components/media/MediaDrop.js'
import { resize } from 'util/imageUtils.js'
import ErrorLine from 'components/ErrorLine.js'
import { uploadMedia } from 'controllers/SocialServiceController'
import { useDispatch, useSelector } from 'react-redux'
import { getStorageAccount } from 'redux/actions/accountActions.js'
import TimerProgress from 'components/mint/TimerProgress.js'
import { createValidEmbed } from 'util/embedUtils.js'
import { parseMessageForUrl } from 'util/postUtils.js'
import { useEffect } from 'react'
import { createLyrics, createScript } from 'util/documentUtils.js'
import { displayError } from 'util/screenUtils.js'
import HarmonizeHeader from 'components/Header/HarmonizeHeader.js'
import Footer from 'components/Footer/Footer.js'
import MediaIcons from 'components/media/MediaIcons'
import ModalDialog from 'components/ModalDialog'
//import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import { setSongDescription } from 'redux/actions/songActions'
import { setSongSummary } from 'redux/actions/songActions'
import { resetSong } from 'redux/actions/songActions'
import { setSongTitle } from 'redux/actions/songActions'
import { setSongMediaIcons } from 'redux/actions/songActions'
import Genres from 'components/utility/Genres'
import { addArtistStudios } from 'controllers/CoreServiceController'
import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import { setSongLyrics } from 'redux/actions/songActions'
import { setSongGenre } from 'redux/actions/songActions'
import { MESSAGE_STATUS } from 'util/postUtils'
import { APPROVAL_STATUS } from 'util/postUtils'
import { MEDIA_TYPES } from 'util/postUtils'
import { DENIAL_REASONS } from 'util/postUtils'
import { Link, useHistory } from 'react-router-dom'
import { UPLOAD_MEDIA_TYPES } from 'util/postUtils'
import AIChat, { aiChatStyles } from './AIChat'
import { getMediaThumbnail } from 'util/imageUtils'
import { getMediaAudio } from 'util/imageUtils'
import { isSupport } from 'util/postUtils'

import { setSongMedia } from 'redux/actions/songActions'
import CreateVideoShort from 'components/harmonize/CreateVideoShort'
import { setSongCreatedAt } from 'redux/actions/songActions'
import { getUploadImageSize } from 'util/imageUtils'
import { getUploadImageQuality } from 'util/imageUtils'
import { setSongUpdatedAt } from 'redux/actions/songActions'
import { getAccountId } from 'redux/actions/accountActions'
import { getMediaVideo } from 'util/imageUtils'
import { setStudios } from 'redux/actions/accountActions'
import { getConnectionChannel } from 'util/socketUtils'
import { getMediaDisplay } from 'util/imageUtils'
import { setRefetchMessageId } from 'redux/actions/fetchActions'
import UploadingWait from 'components/harmonize/UploadingWait'

import StandardTextField from 'components/standard/StandardTextField'
import DisplayLog from 'components/utility/DisplayLog'
import { setIsArtist } from 'redux/actions/accountActions'
import { log } from 'components/utility/DisplayLog'
import { isSupportUser } from 'redux/actions/accountActions'
import roundBrain from '../images/round-brain.png'
import { getStudiosForUser } from 'controllers/CoreServiceController'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEthereum } from '@fortawesome/free-brands-svg-icons'

const buttonStyles = {
  action: { cursor: 'pointer', marginRight: '1em' }
}
let socket
let coverImageFile, mp3File, mp4File, posterFile
export default function CreateHarmonizePost({ messageId = null }) {
  const isEditing = messageId !== null
  const { studios } = useSelector(state => state.account)
  const currentSong = useSelector(state => state.song)
  const { description = '', genre, lyrics = '', mediaIcons,
    summary = '', title = '' } = currentSong
  //console.log(`CreateHarmonizePost messageId ${messageId} song`, useSelector(state => state.song))
  const [error, setError] = useState()
  const [sending, setSending] = useState(false)
  const [messageToEdit, setMessageToEdit] = useState({ _id: null, status: MESSAGE_STATUS.DRAFT })
  const [embedContent, setEmbedContent]
    = useState('')
  const [showAddLyrics, setShowAddLyrics] = useState(false)
  const [lyricsLength, setLyricsLength] = useState(lyrics.length)
  const [showUpload, setShowUpload] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmRights, setConfirmRights] = useState(false)
  const [confirmDeleteSource, setConfirmDeleteSource] = useState()
  const [confirmMove, setConfirmMove] = useState(false)
  const [confirmPublish, setConfirmPublish] = useState(0) //0=none 1=publish 2=republish
  const [confirmUnpublish, setConfirmUnpublish] = useState(false)
  const [createShort, setCreateShort] = useState(false)
  const [creatingHashtag, setCreatingHashtag] = useState(false)
  const [hashtag, setHashtag] = useState('')
  const [messageReadyForMedia, setMessageReadyForMedia] = useState(false)
  /* nextStudio is used when publishing or moving, as the action to take after receiving updatedMessage */
  const [nextStudio, setNextStudio] = useState()
  const [changeStudio, setChangeStudio] = useState(false)
  const [showAi, setShowAi] = useState(false)
  const [waiting, setWaiting] = useState(false)
  const { firstName, lastName, handle, username } = getStorageAccount()
  const userId = getAccountId()
  const { currentRoom, messages } = useSelector(state => state.messages)

  /** Called from MediaIcon after creating the poster image from the first frame of the loaded video */
  const setPosterImage = (videoPoster) => {
    console.log(`setPosterImage`, videoPoster)
    posterFile = videoPoster
    posterFile.isPoster = true
    console.log(`...setPosterImage posterFile`, posterFile)
  }

  const history = useHistory()

  const rightsBody = () => {
    if (mp3File) {
      return `<ol>
      <li>I own 100% of the songwriting rights</li>
      <li>I own 100% of the publishing rights</li>
      <li>This is not a cover song, or it is a cover of a song in the public domain</li>
      <li>Either the song image is not copyrighted, or I own the image copyright
      </ol>`
    } else {
      return `<ol>
      <li>I own 100% of the video rights</li>
      <li>I own the right to include any music in the video soundtrack</li>
      </ol>`
    }
  }
  const displayConfirmRights = () => {
    return (
      `I ${firstName} ${lastName} confirm that, with respect to the files I am about to upload:
      
      ${rightsBody()}

      <i>Remember, to get paid you must have a valid PayPal account with the same a email address you used to
          register with Harmonize.</i> See our <a href='/help/FAQ' target='_blank'>FAQ</a> for more information.
      `

    )
  }
  const dispatch = useDispatch()
  const channelDisconnected = () => {
    setError()
    socket = null
  }

  /**
   * We only need a Studio connection when creating or updating a Message.
   */
  const connectStudio = () => {
    try {
      const channelAddress = `${process.env.REACT_APP_SOCIAL_CHAT_SERVICE}${getConnectionChannel(currentRoom)}`
      log(`{}CreateHarmonizePost connect to ${channelAddress}`)
      socket = io(channelAddress, {
        reconnectionDelay: 10000
      })
      //socketActions(socket, channel, studioOwner)
      socket.on('joined', () => {
        log(`{}CreateHarmonizePost joined Studio`)
      })
      socket.on('approved', () => {
        closePost()
      })
      /* As soon as there is a created Message, this signed-in User is an artist for
         purposed of getting subscribers, vault, etc */
      socket.on('createdMessage', async (newMessage) => {
        log(`{}CreateHarmonizePost received created message`, newMessage)
        setMessageToEdit(newMessage)
        setMessageReadyForMedia(true)
        dispatch(setIsArtist(true))
      })
      socket.on('updatedMessage', async (message) => {
        console.log(`{}CreateHarmonizePost updatedMessage received message`, message)
        setMessageToEdit(message)
        const { media } = message
        setMediaIcons(media)
        setMessageReadyForMedia(true)
        //Possibly change studio if this was the result of a moveToStudio
        setChangeStudio(true)
      })
      socket.on('unauthorized', () => {
        channelDisconnected()
        setError('You are not signed in')
        history.replace('/SignIn')
      })
      socket.on('error', (message) => {
        displayError(message, setError, 32)
      })
    } catch (error) {
      displayError(error, setError, 30)
    }
  }

  /** Connect to the channel saved in the parent Harmonize connection. You can't really save the socket across pages because
 * we need to disconnect when visibility changes occur.
 * @param {*} type 
 * @param {*} message 
 */
  const safeEmit = (type, message) => {
    if (socket) {
      log(`safeEmit ${type}`, message)
      socket.emit(type, message)
    } else {
      console.error(`NO SOCKET FOR safeEmit ${type}`, message)
    }
  }
  /** If isUpdate send 'updateMessage', otherwise 'createMessage'.
   * The former requires a Message _id, the latter does not
   * as it creates a new Message.
   * @param {*} messageToSend 
   * @param {*} isUpdate
   */
  const sendToSocket = (messageToSend, isUpdate) => {
    try {
      safeEmit(isUpdate ? 'updateMessage' : 'createMessage', messageToSend)
      setSending(false)
    } catch (error) {
      displayError(error, setError, 1)
    }
  }

  /**
   * Reset so that a new song can be created
   */
  const clearSong = () => {
    dispatch(resetSong())
    setError('')
    setShowUpload(false)
    setEmbedContent('')
    setShowUpload(true)
    mp3File = null
    mp4File = null
    coverImageFile = null
    posterFile = null
    log('clearSong')
  }

  /**
   * Replace the current page with the signed-in User's currentRoom studio page.
   */
  const closePost = () => {
    console.log('Close post')
    clearSong()
    const { name } = currentRoom
    history.replace(`/@${handle}/${name}`)
  }

  const removeIcons = (ix) => {

    const { mimeType, source } = mediaIcons[ix]
    log(`removeIcons ${ix} ${mimeType} `)
    if (source) {
      setConfirmDeleteSource(mediaIcons[ix])
    } else {
      if (MEDIA_TYPES.IMAGE.includes(mimeType)) {
        coverImageFile = null
      } else if (MEDIA_TYPES.AUDIO.includes(mimeType)) {
        mp3File = null
      } else if (MEDIA_TYPES.VIDEO.includes(mimeType)) {
        mp4File = null
        posterFile = null
      }

      mediaIcons.splice(ix, 1)
      if (mediaIcons.length) {
        dispatch(setSongMediaIcons([...mediaIcons]))
      } else {
        dispatch(setSongMediaIcons([]))
        dispatch(setSongGenre(null))
      }
    }
  }

  const dropped = async (filesReceived) => {
    log('CreateHarmonizePost filesReceived', filesReceived)
    if (filesReceived && filesReceived.length && filesReceived[0]) {
      let file = filesReceived[0]

      setError('')
      const { type: mimeType, name } = file
      log(`mediadrop file ${name} ${mimeType}`, file)
      log('mediaIcons', mediaIcons)
      const hasAudio = MEDIA_TYPES.AUDIO.includes(mimeType)
      const hasImage = MEDIA_TYPES.IMAGE.includes(mimeType)
      const hasVideo = MEDIA_TYPES.VIDEO.includes(mimeType)
      try {
        if (hasImage) {
          const imageSize = getUploadImageSize()
          const imageQuality = getUploadImageQuality()
          resize(file, imageSize, imageSize, imageQuality, async () => {
            setShowUpload(false)
            log(`set coverImageFile ${name}`)
            coverImageFile = file
            dispatch(setSongMediaIcons([...mediaIcons, { index: mediaIcons.length, name, mimeType, file }]))
          }, true)
        } else if (hasAudio) {
          log(`set mp3File ${name}`)
          mp3File = file
          dispatch(setSongMediaIcons([...mediaIcons, { index: mediaIcons.length, name, mimeType, file }]))
        } else if (hasVideo) {
          log(`set mp4File ${name}`)
          mp4File = file
          dispatch(setSongMediaIcons([...mediaIcons, { index: mediaIcons.length, name, mimeType, file }]))
        } else {
          log(`mimeType ${mimeType} is not supported`)
          displayError({ message: `mimeType ${mimeType} is not supported` }, setError)
        }
      } catch (error) {
        setWaiting(false)
        log(`Unable to save file ${name}`)
        displayError(`Unable to read file`, setError, 31)
      }
    } else {
      displayError('No file selected', setError, 2)
    }

  }


  const displayDropzone = () => {

    if (showUpload) {
      const hasAudio = hasMediaType(MEDIA_TYPES.AUDIO)
      const hasImage = hasMediaType(MEDIA_TYPES.IMAGE)
      const hasVideo = hasMediaType(MEDIA_TYPES.VIDEO)
      const prompt = !(hasAudio || hasVideo) ? 'WAV, MP3 or MP4'
        : 'image'
      //log(`displayDropzone hasAudio ${hasAudio} genre ${genre !== undefined} hasImage ${hasImage}`)
      const mimeTypes = hasAudio ? UPLOAD_MEDIA_TYPES.IMAGE : UPLOAD_MEDIA_TYPES.NOT_IMAGE
      if (!(hasAudio || hasVideo) || (hasAudio && genre && !hasImage)) {
        return (
          <div style={{ color: 'black', padding: '1em' }}>
            <MediaDrop
              mimeTypes={mimeTypes}
              prompt={`To select your ${prompt}, drag and drop or click here`}
              onSelected={async (files) => {
                log(`CreateHarmonizePost onSelected received ${files.length} files`)
                await dropped(files)
              }
              }
              onError={setError}
              multiple={false}
              dropWidth='100%'
            />
          </div>
        )
      }
    }
  }

  const displaySupportDropzone = () => {
    if (showUpload) {

      const mimeTypes = MEDIA_TYPES.IMAGE
      const hasImage = hasMediaType(MEDIA_TYPES.IMAGE)
      if (!hasImage) {

        return (
          <div style={{ color: 'black', padding: '1em' }}>

            <MediaDrop
              mimeTypes={mimeTypes}
              prompt={`To select your image, drag and drop or click here`}
              onSelected={(files) => dropped(files)}
              onError={setError}
              multiple={false}
              dropWidth='100%'
            />
          </div>
        )
      }
    }
  }

  const displayLyrics = () => {
    if (showAddLyrics) {
      const textType = hasMediaType(MEDIA_TYPES.VIDEO) ? 'Script' : 'Lyrics'
      return (
        <div style={{ padding: '1em', border: '1px solid black' }}>
          <StandardTextField
            initialValue={lyrics}
            change={(event) => {
              const text = event.target.value
              dispatch(setSongLyrics(text))
              setLyricsLength(text.length)
            }}
            multiline
            rows={10}
            label={`${textType} (${lyricsLength} of ${process.env.REACT_APP_MAX_HARMONIZE_MESSAGE_LENGTH} characters)`}

          />
          <Button
            color="info"
            title={`Close ${textType}`}
            style={{ cursor: 'pointer', display: 'flex', marginLeft: 'auto', marginRight: 'auto' }}
            onClick={() => setShowAddLyrics(false)}>
            Close
          </Button>
        </div>
      )
    }
  }

  const getMediaStatus = (status) => {
    const hasMediaToPrepare = mp3File || mp4File
    let updatedStatus = status
    switch (status) {
      default:
      case MESSAGE_STATUS.DRAFT:
        if (hasMediaToPrepare) {
          updatedStatus = MESSAGE_STATUS.MEDIA_PENDING_DRAFT
        }
        break
      case MESSAGE_STATUS.PUBLISHED:
        if (hasMediaToPrepare) {
          updatedStatus = MESSAGE_STATUS.MEDIA_PENDING_PUBLISHED
        }
        break
    }
    return updatedStatus
  }

  /**
 * Parses the message for embedded URLS that support required og tags. Then if
 * there is any embedContent, validates and creates an embed instance. If there lyrics that is sent as document.
 * 
 * The Message inherits the currentRoom accessType, which is currently always PRIVATE because these actions
 * can only occur in the PRIVATE studio. Publication and moving must change the accessType on the Message.
 * @returns { message, accessType, embed, attachment, name, embeds, summary, firstName, lastName, handle }
 * */
  const formatMessage = async () => {
    let embed, attachment
    const parsedMessage = await parseMessageForUrl(description)
    if (embedContent.length) {
      log('embedContent', embedContent)
      embed = createValidEmbed(embedContent)
    }
    if (lyricsLength) {
      attachment = hasMediaType(MEDIA_TYPES.VIDEO) ? createScript(lyrics) : createLyrics(lyrics)
      log(`formatMessage attachment`, attachment)
    }
    const { accessType } = currentRoom
    const embeds = messageToEdit && messageToEdit.embeds ? messageToEdit.embeds : null
    return {
      message: parsedMessage, accessType, embed, attachment, name: title,
      embeds, summary, firstName, lastName, handle
    }
  }

  /**
   * When updating there may be both embedContent (the iframe) and an array of embeds the latter of which may contain
   * an existing version of the embedContent. If there is an existing version update it if the content has changed.
   * If there is no existing version then push it into the embeds array.
   *
   * The comparisons are on embedType.
   * @param {*} embed
   * @param {*} embeds
   * @returns Updated embeds
   */
  const addOrUpdateEmbed = (embed, embeds) => {
    const existingEmbed = embeds.find((e) => e.embedType === embed.embedType)
    if (existingEmbed) {
      if (existingEmbed.embedContent !== embed.embedContent) {
        const ix = embeds.findIndex((e) => e.embedType === embed.embedType)
        embeds.splice(ix, 1, embed)
      }
    } else {
      embeds.push(embed)
    }
    return embeds
  }

  /**
   * 
   * This is *always* to ensure that the Message status is correct. The Social Service responds with either
   * "createdMessage" or "updatedMessage". In either case, the messageReadyForMedia flag is sent, which triggers
   * a call to uploadAllMedia. If there is any new media, it is then sent.
   * 
  * This is sent to the Social Service, where the Message expects both the roomId (for connection) and the roomName
  * for use as the media root folder.
  * 
  * The status sent with the message is determined by calling getMediaStatus(originalStatus). This will
  * set one of the MEDIA_PENDING statuses if an mp3File or mp4File is waiting to be sent.
  * 
  * If this is created in the Support category, a new Message has its approval set to APPROVAL_STATUS.APPROVED.
  *
  * The roomId sent with the message is the actual _id of the Room and not the associated Asset id.
  * 
  * @todo There should be a success return message so that the songReducer can be reset.

  * @param {*} originalStatus  If true and isEditing is false then the new Message is created with the specified status. 
    Default is 1=PUBLISHED
  */
  const send = async (originalStatus) => {
    const isUpdate = messageToEdit._id !== null
    const messageBlock = await formatMessage()
    if (isEditing) {
      log(`send isEditing ${isEditing} id ${messageToEdit._id}`)
      messageBlock.messageId = messageToEdit._id
    }
    const status = getMediaStatus(originalStatus)
    log(`send isUpdate ${isUpdate} updatedStatus ${status} original status ${originalStatus}`, messageBlock)
    setSending(true)
    try {
      const { name: roomName, _id: roomId, channel } = currentRoom
      const { name: channelName } = channel
      const { message, accessType, embed, attachment, name, embeds, summary, firstName, lastName, handle } =
        messageBlock
      let messageToSend
      if (isUpdate) {
        const { _id, publishedAt } = messageToEdit
        messageToSend = { messageId: _id, message, name, status, summary, genre }
        if (status === MESSAGE_STATUS.PUBLISHED && !publishedAt) {
          messageToSend.publishedAt = new Date()
        }
        const { approved } = getStorageAccount()
        if (approved) {
          messageToSend.approvalTarget = { roomId, roomName }
          log(`send update approved user approval target`, messageToSend.approvalTarget)
        }
      } else {
        const category = isSupportUser() ? 'Support' : mp3File ? 'Music' : 'Video'
        messageToSend = {
          message,
          accessType,
          summary,
          name,
          category,
          userId,
          username,
          roomName,
          roomId,
          status,
          genre,
          firstName,
          lastName,
          handle,
          channel: channelName,
        }
        if (status === MESSAGE_STATUS.PUBLISHED) {
          messageToSend.publishedAt = new Date()
        }
        if (isSupport(messageToSend)) {
          messageToSend.approval = APPROVAL_STATUS.APPROVED
        }

      }
      if (embeds) {
        messageToSend.embeds = embeds
      }
      if (embed) {
        if (messageToSend.embeds) {
          messageToSend.embeds = addOrUpdateEmbed(embed, embeds)
        } else {
          messageToSend.embeds = [embed]
        }
      }
      if (attachment) {
        messageToSend.attachments = [attachment]
      }
      if (isEditing) {
        //Flag to the Social Service to prevent a spurious "new post" email
        messageToSend.isUpdate = true
      }
      log(`sendToSocket`, messageToSend)
      sendToSocket(messageToSend, isUpdate)
    } catch (error) {
      setSending(false)
      displayError(error, setError, 4)
    }
  }

  /**
   * This method is only called after a send, followed by the Social Service response.
   * If there is no media to send, call setSending(false) to dismiss the Timer progress. Otherwise,
   * push each pedning media instance into mediaToSend, then loop through that calling
   * upload.
   */
  const uploadAllMedia = async () => {
    log('uploadAllMedia messageToEdit', messageToEdit)
    if (mp3File || mp4File || coverImageFile || posterFile) {
      let mediaToSend = []
      if (coverImageFile) {
        mediaToSend.push(coverImageFile)
        log('mediaToSend cover image', mediaToSend)
      }
      if (mp3File) {
        log('uploadAllMedia mp3File', mp3File)
        mediaToSend.push(mp3File)
        log('mediaToSend', mediaToSend)
      }
      if (mp4File) {
        log('uploadAllMedia mp4File', mp4File)
        mediaToSend.push(mp4File)
        log('mediaToSend', mediaToSend)
      }
      if (posterFile) {
        log('uploadAllMedia posterFile', posterFile)
        mediaToSend.push(posterFile)
        log('mediaToSend', mediaToSend)
      }
      log(`uploadAllMedia mp3File ${mp3File ? true : false} mp4File ${mp4File ? true : false} 
      coverImageFile ${coverImageFile ? true : false}
            posterFile ${posterFile ? true : false}
      `, mediaToSend)
      let ix = 0
      for await (const md of mediaToSend) {
        await upload(md, ++ix === mediaToSend.length)
      }
    } else {
      console.log('...no media to upload')
      setSending(false)
    }
  }

  /**
   * An upload requires an existing Message so that the messageId:
   *    * 1) Can be used on the Social Service to update the Message with uploaded image mediaSchema.
   * 2) Can be sent to the Core Service so that it can call back to the Social Service
   *    to update mediaSchema for media created on the Core Service (mp3s and mp4s.)
   * 
   * This uploads images to Social Service, and audio or video to Core Service. In the case of
   * images, the mediaSchema for the image is returned and saved into allMediaSchemas. For
   * audio or video, the updating of the media for the Message is performed on the Core Service.
   * 
   * @param {*} fileToUpload    A File object
   * @param {*} isLast          True if this is the last File to upload
   */
  const upload = async (file, isLast) => {
    console.log(`upload isLast ${isLast}`, file)
    const { name } = currentRoom
    const { _id: messageId, name: messageName } = messageToEdit
    setSending(true)
    if (file) {
      const { type: mimeType, name: fileName, isPoster } = file
      const isImage = UPLOAD_MEDIA_TYPES.IMAGE.includes(mimeType)
      try {
        log(`{}CreateHarmonizePost begin Upload of ${fileName}`)
        const result = await uploadMedia(file, { name, username, messageId, messageName, isPoster },
          isImage)
        if (result) {
          log(`{}CreateHarmonizePost Upload of ${fileName} completed isImage ${isImage} isLast ${isLast}, result`, result)
          if (isImage) {
            //Tell the guy listening in the Studio to refetch this Message so the image will be displayed
            log(`{}CreateHarmonizePost ...setRefetchMessageId${messageId})`)
            dispatch(setRefetchMessageId(messageId))
            if (isLast) {
              setMessageToEdit(result)
            }
          }
          if (isLast) {
            setSending(false)
            closePost()
          }
        } else {
          displayError({ message: `Upload of ${fileName} failed (${result.statusCode})` }, setError, 8)
          setSending(false)
        }
      }
      catch (error) {
        setSending(false)
        displayError({ message: `Upload of ${fileName} failed` }, setError, 3)
      }
    } else {
      setSending(false)
      displayError({ message: `No media to upload` }, setError, 41)
    }
  }

  const displayAddLyrics = () => {
    if (title && (hasMediaType(MEDIA_TYPES.AUDIO) || hasMediaType(MEDIA_TYPES.VIDEO))) {
      return (
        <div style={{ cursor: 'pointer' }} onClick={() => { setShowAddLyrics(!showAddLyrics) }}
          title={hasMediaType(MEDIA_TYPES.VIDEO) ? 'Script' : 'Lyrics'} >
          <PostAddTwoTone style={{
            fontSize: '3em', cursor: 'pointer',
            display: 'flex', marginLeft: 'auto', marginRight: 'auto'
          }} />
        </div>
      )
    }
  }
  /**
   * 
   * Send a deleteMessageMedia referencing the index within media
   * 
   * 
   * When that succeeds the Social Service will send an updateMessage back that is then
   * used to update the current message.
   * @param {*} mediaIcon 
   */
  const deleteMediaElement = async (mediaIcon) => {
    const { source, mimeType } = mediaIcon
    const { media } = messageToEdit
    log(`deleteMediaElement ${mimeType} ${source}`, media)
    const mediaIndex = media.findIndex(m => {
      return m && m.source === source
    })
    if (mediaIndex !== -1) {
      try {
        safeEmit('deleteMessageMedia', { mediaIndex, messageId })
      } catch (error) {
        displayError(error, setError, 5)
      }
    }
    setConfirmDeleteSource(null)
  }

  const sufficient = () => {
    return ((hasRequiredAudio() && hasRequiredImage() && title && genre)
      ||
      (hasMediaType(MEDIA_TYPES.VIDEO) && title && genre))
      || (isSupport(messageToEdit) && title && description)
  }
  const canUpdate = () => {
    return isSupport(messageToEdit) || canSave() || (isEditing && sufficient())
  }

  /** For unclear reasons just testing for mp3File (without the comparison to null) fails */
  const canSave = () => {
    const saveable = isSupportUser() ? title && description :
      !isEditing &&
      sufficient()
    return saveable
  }

  const checkForHashTag = () => {
    if (creatingHashtag && hashtag.trim().length) {
      log(`Create hashtag ${hashtag}`)
      setHashtag('')
      setCreatingHashtag(false)
    }
  }

  const getHashtags = () => {
    const hashtags = description.match(/#\w+/g) || []
    log(hashtags)
  }

  const editDescription = () => {
    if (isSupport(messageToEdit)) {
      return <Editor value={description} onChange={(event) => {
        dispatch(setSongDescription(event.target.value))
      }} />
    } else {
      return (
        <StandardTextField
          rows={10}
          label='Story'
          multiline
          initialValue={description}
          change={(event) => {
            const { target } = event
            if (creatingHashtag) {
              setHashtag(target.value)
            }
          }}
          keyPress={(event) => {
            const { key } = event
            if (key === 'Enter') {
              //checkForHashTag()
              parseMessageForUrl(description)
              getHashtags()
            }
          }}
          blur={(event) => {
            dispatch(setSongDescription(event.target.value))
            //Button clicks are swallowed by onBlur. This code redispatches the evnet.
            if (event.relatedTarget) {
              event.relatedTarget.click()
            }
          }} />
      )
    }
  }
  const displayForm = () => {

    if (isSupportUser() || (hasMediaType(MEDIA_TYPES.VIDEO) && genre) || (hasRequiredAudio() && genre)) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '85vw' }}>

          <StandardTextField
            initialValue={title}
            label='Title'
            rows={2}
            change={(event) => {
              const { target } = event
              if (creatingHashtag) {
                setHashtag(target.value)
              }
            }}
            keyPress={(event) => {
              const { key } = event
              if (key === 'Enter') {
                getHashtags()
              }
            }}
            blur={(event) => {
              dispatch(setSongTitle(event.target.value))
              //Button clicks are swallowed by onBlur. This code redispatches the evnet.
              if (event.relatedTarget) {
                event.relatedTarget.click()
              }
            }} />
          <br />
          {editDescription()}

          {displayAddLyrics()}
        </div>
      )
    }

  }

  const displayActions = () => {
    const { name: roomName, accessType } = currentRoom
    const moveToName = roomName.toLowerCase() === 'home' ? 'public' : 'home'
    const { approved } = getStorageAccount()
    const { status, approval } = messageToEdit
    const isDraft = status === MESSAGE_STATUS.DRAFT
    const canPublish = isSupport(messageToEdit)
      || (accessType === ACCESS_TYPES.PRIVATE && status === MESSAGE_STATUS.DRAFT
        && !mp3File && !coverImageFile && !mp4File)
    let publishLabel = 'Publish'
    let publishTitle = `Publish to ${roomName}`
    if (isEditing) {

      switch (approval) {
        case APPROVAL_STATUS.PENDING:
          return (
            <Button
              color="info"
              title='Pending approval'
              style={{ cursor: 'default' }}
            >
              Pending
            </Button>
          )
        default:
        case APPROVAL_STATUS.DECLINED:
          publishLabel = 'Republish'
          publishTitle = `Not approved. Please update your content, then click Republish`
        // eslint-disable-next-line no-fallthrough
        case APPROVAL_STATUS.NONE:
          return (
            <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
              {canPublish && sufficient() ? <Button
                color="rose"
                title={publishTitle}
                style={buttonStyles.action}
                onClick={() => setConfirmPublish(approval === APPROVAL_STATUS.NONE ? 1 : 2)}>
                {publishLabel}
              </Button> : null}
              {isSupport(messageToEdit) ?
                <Button
                  color="success"
                  style={{ cursor: 'pointer' }}
                  title={`Update post in ${roomName}`}
                  onClick={() => send(MESSAGE_STATUS.PUBLISHED)}>
                  Update
                </Button> :
                <div>
                  <Button disabled={!canUpdate()}
                    color={approved ? 'success' : 'warning'}
                    style={{ cursor: 'pointer' }}
                    title={`Update ${isDraft ? 'draft' : 'published'} in ${roomName}`}
                    onClick={() => (mp3File !== null || mp4File !== null || coverImageFile !== null) ? setConfirmRights(true)
                      : send(status)}>
                    Update
                  </Button>
                  {!isDraft && <Button
                    color="rose"
                    title={`Unpublish from ${roomName}`}
                    style={{ cursor: 'pointer', marginLeft: '1em' }}
                    onClick={async () => setConfirmUnpublish(true)}>
                    Unpublish
                  </Button>}
                  {!isDraft && <Button
                    color="rose"
                    title={`Move to ${moveToName}`}
                    style={{ cursor: 'pointer', marginLeft: '1em' }}
                    onClick={async () => setConfirmMove(true)}>
                    Move
                  </Button>}
                </div>
              }
            </div>
          )

      }
    } else {
      return (
        <div style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'center' }}>
          <Button
            color="primary"
            title='Clear this form'
            style={buttonStyles.action}
            onClick={() => clearSong()}>
            Clear
          </Button>
          {isSupportUser() ?
            <Button disabled={!canSave()}
              color="success"
              style={{ cursor: 'pointer' }}
              title={`Save post in ${roomName}`}
              onClick={() => send(MESSAGE_STATUS.PUBLISHED)}>
              Save
            </Button> :

            <Button disabled={!canUpdate()}
              color="success"
              style={{ cursor: 'pointer' }}
              title={`Save draft in ${roomName}`}
              onClick={() => (mp3File !== null || coverImageFile !== null || mp4File !== null) ? setConfirmRights(true)
                : send(MESSAGE_STATUS.DRAFT)}>
              Save
            </Button>}
        </div>
      )
    }
  }

  /**
   * For studio category Music:
   * 
   * Only songs in the private room can be published. Songs can only be created or edited in the private room.
   * Once published, a song can be set back to Unpublished (DRAFT) from a non-private room.
   * 
   * For studio category Support:
   * 
   * Only the support user (currently info@harmonize.social) can edit, and there is no publication approval required.
   * 
   * @returns 
   */
  const displayTextAndActions = () => {
    if (!isEditing || messageToEdit) {
      return (
        <>
          {displayForm()}
          <div >
            <div style={{ alignItems: 'center' }}>

              {displayActions()}
              <Button
                color="info"
                title='Go back'
                style={buttonStyles.action}
                onClick={() => {
                  closePost()
                }}>
                Close
              </Button>

            </div>

          </div>
          {isEditing ? <div style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'center', marginTop: '1em', paddingBottom: '5em' }}>
            <div title='Click to delete post'><DeleteForeverTwoTone
              color='error'
              style={{ fontSize: '3em', cursor: 'pointer' }}
              onClick={(evt) => {
                evt.stopPropagation()
                setConfirmDelete(!confirmDelete)
              }}
            /> </div>
            {/*
            <div
              title=
              'Click to mint NFT'
              style={{...aiChatStyles.button,...{padding:0}}}
              onClick={(evt) => {
                evt.stopPropagation()
                history.push(`/MintNFT/${messageId}`)
              }}
            >
              <FontAwesomeIcon icon={faEthereum} style={{ fontSize: '1.5em', color: 'purple' }} />
            </div>
            */}
            <div
              title=
              'Click to use AI'
              style={aiChatStyles.button}
              onClick={(evt) => {
                evt.stopPropagation()
                setShowAi(!showAi)
              }}
            >
              <img
                src={roundBrain}
                alt=' '
                style={{
                  height: '2em',
                }}
              />

            </div>

          </div> : null}

        </>

      )
    }
  }

  const displayGenre = () => {
    if (!isSupportUser() && mediaIcons.length) {
      return <Genres />
    }
  }

  const displayCreateShort = () => {
    const { _id: roomId } = currentRoom
    const songAndRoom = { ...currentSong, roomId, _id: messageId, userId }
    return (<div style={{ display: 'flex', justifyContent: 'center', marginBottom: '5em', position: 'relative' }}>
      <CreateVideoShort song={songAndRoom} currentRoom={currentRoom} close={() => setCreateShort(false)} />
    </div>)
  }

  const displayLyricsOrMain = () => {
    const { name: roomName } = currentRoom
    const { approved } = getStorageAccount()
    console.log(`displayLyricesOrMain approved ${approved}`, currentRoom)
    if (showAi) {
      return (
        <><div style={{ justifyContent: 'right', width: '100%', display: 'flex' }} title='Close AI'>
          <HighlightOffTwoTone style={{ fontSize: '2em' }} onClick={() => setShowAi(false)} />
        </div>
          <div style={{ backgroundColor: 'white', height: '70vh' }}>
            <AIChat room={currentRoom} chatHeight='70vh' roomId={currentRoom._id} ownerOnly messageId={messageId} /> </div>
        </>)

    } else
      if (!(approved || isSupport(messageToEdit)) && isEditing && messageToEdit.status === MESSAGE_STATUS.PUBLISHED) {
        return (
          <div>
            <Button
              color="info"
              title='Go back'
              style={{ cursor: 'pointer' }}
              onClick={() => closePost()}>
              Close
            </Button>
            <Button
              color="rose"
              title={`Move to ${roomName}`}
              style={{ cursor: 'pointer' }}
              onClick={async () => setConfirmMove(true)}>
              Move
            </Button>
            {/*isNewFormat(currentSong) ?
              <Button
                color="rose"
                title={`Create video short`}
                style={{ cursor: 'pointer' }}
                onClick={() => setCreateShort(true)}>
                Video Short
              </Button>
        : null*/}
            <Button
              color="rose"
              title={`Unpublish from ${roomName}`}
              style={{ cursor: 'pointer' }}
              onClick={async () => setConfirmUnpublish(true)}>
              Unpublish
            </Button>
          </div>
        )
      } else if (showAddLyrics) {
        return displayLyrics()
      } else {
        return (
          <>
            <div>
              {waiting ? <TimerProgress /> : <MediaIcons imageClicked={removeIcons}
                mediaIcons={mediaIcons}
                setPosterImage={mediaIcons.findIndex(mi => mi.mimeType === 'image/jpeg') === -1 ? setPosterImage : null} />}
            </div>
            {isSupportUser() ? displaySupportDropzone() : displayDropzone()}
            {displayGenre()}
            {displayTextAndActions()}
          </>
        )
      }
  }
  const displayStatus = () => {
    if (isEditing) {
      const { approval, approvalReason } = messageToEdit
      switch (approval) {
        default:
          return null
        case APPROVAL_STATUS.DECLINED:
          return <div style={{ justifyContent: 'center', display: 'grid' }}><span style={{ justifyContent: 'center', color: 'red', display: 'flex' }}>Approval declined. {DENIAL_REASONS[approvalReason]}
          </span>
            <Link to='/help/Approvals'>Click here for more information</Link>
          </div>
      }
    }
  }

  const displayLog = () => {
    if (process.env.REACT_APP_SHOW_LOG === 'true') {
      return <DisplayLog />
    }
  }
  const displayMain = () => {
    console.log(`{}CreateHarmonizePost displayMain sending ${sending}`)
    if (sending) {
      return <UploadingWait />
    } else {
      const { accessType } = currentRoom
      if (createShort) {
        return displayCreateShort()
      } else {
        let deleteLabel = 'image'
        if (confirmDeleteSource) {
          const { mimeType: deleteMimeType } = confirmDeleteSource
          deleteLabel = MEDIA_TYPES.VIDEO.includes(deleteMimeType) ? 'video' :
            MEDIA_TYPES.AUDIO.includes(deleteMimeType) ? 'audio' : 'image'
        }
        return (
          <div style={{
            marginRight: '1em', marginLeft: '1em', textAlign: 'center',
            paddingBottom: process.env.REACT_APP_MODE === 'development' ? '50vh' : '10vh'
          }}>
            {!showAi ? <h4 style={{ textAlign: 'center' }}>{title ? `Edit ${title}`
              : isSupportUser() ? 'Create Support Post'
                : 'Create Song or Video'}</h4> : null}
            {displayStatus()}
            <ErrorLine error={error} />
            {displayLyricsOrMain()}
            {displayLog()}
            <ModalDialog
              title='Confirm Delete'
              message={`Are you sure you want to permanently delete ${title}?`}
              close={() => setConfirmDelete(false)}
              open={confirmDelete}
              noLabel='No'
              no={() => setConfirmDelete(false)}
              yesLabel='Yes'
              yes={async () => {
                setConfirmDelete(false)
                safeEmit('deleteMessage', { messageId })
                closePost()
              }}
            />
            <ModalDialog
              title='Confirm Delete Media'
              message={`Are you sure you want to permanently delete this ${deleteLabel}?`}
              close={() => setConfirmDeleteSource()}
              open={confirmDeleteSource ? true : false}
              noLabel='No'
              no={() => setConfirmDeleteSource()}
              yesLabel='Yes'
              yes={async () => {
                await deleteMediaElement(confirmDeleteSource)
              }}
            />
            <ModalDialog
              title='Confirm Publish'
              message={`Are you sure you want to ${confirmPublish === 1 ? 'publish' : 'republish'} ${title}?`}
              close={() => setConfirmPublish(0)}
              open={confirmPublish !== 0}
              noLabel='No'
              no={() => setConfirmPublish(0)}
              yesLabel='Yes'
              yes={() => {
                publish()
              }} />
            <ModalDialog
              title='Confirm Unpublish'
              message={`Are you sure you want to unpublish ${title}?`}
              close={() => setConfirmUnpublish(false)}
              open={confirmUnpublish}
              noLabel='No'
              no={() => setConfirmUnpublish(false)}
              yesLabel='Yes'
              yes={() => {
                setConfirmUnpublish(false)
                unpublish()
              }}
            />
            <ModalDialog
              title='Confirm Move'
              message={`Are you sure you want to move ${title} to your ${accessType === ACCESS_TYPES.PROTECTED ? 'public' : 'home'} studio?`}
              close={() => setConfirmMove(false)}
              open={confirmMove}
              noLabel='No'
              no={() => setConfirmMove(false)}
              yesLabel='Yes'
              yes={() => {
                moveToStudio()
              }}
            />
            <ModalDialog
              title='Confirm Ownership'
              content={() => displayConfirmRights()}
              close={() => setConfirmRights(false)}
              open={confirmRights}
              noLabel='No'
              no={() => { setConfirmRights(false) }}
              yesLabel='I Confirm'
              yes={() => {
                setConfirmRights(false)
                send(isEditing ? messageToEdit.status : MESSAGE_STATUS.DRAFT)
              }}
            />
          </div>
        )
      }
    }
  }

  /**
   * 
   * @param {*} mediaType A MEDIA_TYPE
   * @returns 
   */
  const hasMediaType = (mediaType) => {
    for (const entry of mediaIcons) {
      const { mimeType } = entry
      if (mediaType.includes(mimeType)) {
        return true
      }
    } return false
  }

  const hasRequiredAudio = () => {
    return hasMediaType(MEDIA_TYPES.AUDIO)
  }

  const hasRequiredImage = () => {
    return hasMediaType(MEDIA_TYPES.IMAGE)
  }

  /**
   * Create the icons that are displayed as MediaIcons and that determine what kind of
   * media is stored in this Message. Note that this is only for display purposes --
   * it does not change the underlying mediaSchema stored with the Message.
   * 
   * Since there (will eventually be) at least two images -- display and thumbnail -- this
   * only returns the thumbnail for icon display purposes. It strips the "t_" from the front of
   * the sourceName, again for display purposes only.
   * @param {*} media 
   */
  const setMediaIcons = (media) => {
    log(`setMediaIcons`, media)
    if (media) {
      let icons = []
      dispatch(setSongMediaIcons([]))

      const displayImage = getMediaDisplay(media)
      if (displayImage) {
        icons.push(displayImage)
      } else {
        const mediaImage = getMediaThumbnail(media)
        if (mediaImage) {
          icons.push(mediaImage)
        }
      }
      const audioIcon = getMediaAudio(media)
      if (audioIcon) {
        icons.push(audioIcon)
      }
      const videoIcon = getMediaVideo(media)
      if (videoIcon) {
        icons.push(videoIcon)
      }
      log('...icons', icons)
      dispatch(setSongMediaIcons(icons))
    }

  }

  /**
   * Move this post either to the PUBLIC or the HOME studio. This changes the
   * Message accessType to match that of the target studio.
   */
  const moveToStudio = () => {
    const { name } = currentRoom
    const moveToPublic = name.toLowerCase() === 'home'

    const target = studios.find(s => moveToPublic ? s.name.toLowerCase() === 'public' : s.name.toLowerCase() === 'home')
    log(`moveToStudio public ${moveToPublic}`, studios)
    const { _id: roomId, name: roomName } = target
    let updatedMessage = {
      ...messageToEdit, messageId: messageToEdit._id, roomId, roomName,
      accessType: moveToPublic ? ACCESS_TYPES.PUBLIC : ACCESS_TYPES.PROTECTED,
      isUpdate: true
    }
    log(`moveToStudio public ${moveToPublic}`, updatedMessage)
    setConfirmMove(false)
    setNextStudio(moveToPublic ? `/@${handle}/public` : `/@${handle}/home`)
    sendToSocket(updatedMessage, true)
  }

  /**
   * When attempting to publish,   Client should check approval
    DECLINED sets Publish button back to Draft
    PENDING sets Publish button to Pending
   * @param {*} target  The _id and name of the Studio to which this Message should be published 
   * @param {*} status  MESSAGE_STATUS
   * @param {*} republish If true set APPROVAL_STATUS.NONE
   */
  const pubUnpub = (target, status, republish) => {
    const { _id: roomId, name: roomName } = target
    let updatedMessage = {
      ...messageToEdit, messageId: messageToEdit._id, status, roomId, roomName, approvalTarget: { roomId, roomName }
    }
    if (republish) {
      updatedMessage.approval = APPROVAL_STATUS.NONE
    } else if (status === MESSAGE_STATUS.PUBLISHED) {
      updatedMessage.publishedAt = new Date()
      updatedMessage.accessType = ACCESS_TYPES.PROTECTED
    }
    log(`pubUnpub ${status} ${republish}`, updatedMessage)
    setNextStudio(`/@${handle}/home`)
    sendToSocket(updatedMessage, true)
  }

  const publish = () => {
    log(`publish ${confirmPublish}`)
    const homeStudio = studios.find(s => s.accessType === ACCESS_TYPES.PROTECTED)
    if (homeStudio) {
      pubUnpub(homeStudio, MESSAGE_STATUS.PUBLISHED, confirmPublish === 2)
    }
    setConfirmPublish(0)
  }

  const unpublish = () => {
    const privateStudio = studios.find(s => s.accessType === ACCESS_TYPES.PRIVATE)
    if (privateStudio) {
      log(`unpublish handle ${handle} target studio`, privateStudio)
      pubUnpub(privateStudio, MESSAGE_STATUS.DRAFT, true)
      history.replace(`/@${handle}/private`)
    }
  }

  /**
   * Get all studios for the signed-in User. If there is no private studio,
   * then add the artist studios.
   * @param {*} st 
   */
  const studiosReady = (st) => {
    console.log('Got studios', st)
    dispatch(setStudios(st))
    setShowUpload(true)
    const hasPrivate = st.find(s => s.name.toLowerCase() === 'private')
    if (!hasPrivate) {
      addArtistStudios()
        .then(s => { console.log('Received studios', s); dispatch(setStudios(s.studios)) })
        .catch(error => displayError(error, setError, 6))
    }
  }
  useEffect(() => {
    if (messageReadyForMedia) {
      log(`{}CreateHarmonizePost messageReadyForMedia, now upload media`)
      uploadAllMedia()
        .then(() => setMessageReadyForMedia(false))
        .catch(() => setMessageReadyForMedia(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageReadyForMedia])

  useEffect(() => {
    log(`{}CreateHarmonizePost changeStudio ${changeStudio} nextStudio ${nextStudio}`)
    if (changeStudio && nextStudio) {
      history.replace(nextStudio)
      setNextStudio()
      setChangeStudio(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeStudio])
  useEffect(() => {
    connectStudio()
    getStudiosForUser().then(s => {
      studiosReady(s)
    }).catch(error => displayError(error, setError))

    return () => socket.disconnect()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  /*
  useEffect(() => {
 
    // This is the correct file reference 
    const worker = new Worker(new URL('../webworker/uploadWorker.js', import.meta.url))
    workerRef.current = worker
    workerRef.current.onmessage = (event) => {
      //setResult(event.data)
    }
 
    return () => {
      console.log('CreateHarmonizePost terminate')
      workerRef.current.terminate()
    }
  }, [])
  */


  useEffect(() => {
    log(`{}CreateHarmonizePost useEffect isEditing ${isEditing}`)
    if (isEditing) {
      const messageToEdit = messages.find(m => m._id === messageId)
      if (!messageToEdit) {
        console.error(`Unable to find message ${messageId} in messages`, messages)
        displayError(`Unable to find message ${messageId} in messages`, setError, 7)
      } else {
        log('{}CreateHarmonizePost...messageToEdit', messageToEdit)
        setMessageToEdit(messageToEdit)
        const { createdAt, message, name, attachments, embeds, media, summary, genre, updatedAt } = messageToEdit

        dispatch(setSongCreatedAt(createdAt))
        dispatch(setSongUpdatedAt(updatedAt))
        dispatch(setSongDescription(message))
        dispatch(setSongGenre(genre))
        dispatch(setSongTitle(name))
        dispatch(setSongSummary(summary))
        if (attachments && attachments.length) {
          dispatch(setSongLyrics(attachments[0].attachmentContent))
          setLyricsLength(attachments[0].attachmentContent.length)
        } else {
          dispatch(setSongLyrics(''))
          setLyricsLength(0)
        }
        if (embeds && embeds.length) {
          setEmbedContent(embeds[0].embedContent)
        }
        if (media && media.length) {
          dispatch(setSongMedia(media))
          setMediaIcons(media)
        } else {
          dispatch(setSongMedia([]))
          dispatch(setSongMediaIcons([]))
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditing, messages])
  return (
    <div >
      <HarmonizeHeader />
      {displayMain()}
      <Footer />
    </div>
  )
}
